var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "사업안내",
            "tabActive": "입지환경",
            "bg": "/images/sub/business/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("사업안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first pb-30px pb-md-40px",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("입지환경")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('v-card', {
      attrs: {
        "tile": "",
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary justify-center pa-4px mb-4px"
    }, [_c('tit', {
      staticClass: "tit--sm"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1), _c('v-img', {
      attrs: {
        "src": item.image
      }
    }), _c('v-card-text', {
      staticClass: "text-center px-0 pb-0"
    }, [_c('tit', [_c('div', {
      staticClass: "tit--sm font-weight-semibold grey--text"
    }, [_vm._v(" " + _vm._s(item.text) + " ")]), _c('div', {
      staticClass: "primary--text mt-4px"
    }, [_c('div', {
      staticClass: "font-size-24 font-size-md-36"
    }, [_vm._v(_vm._s(item.minutes) + "분")]), _c('div', {
      staticClass: "tit--xxs"
    }, [_vm._v("(" + _vm._s(item.transport) + ")")])])])], 1)], 1)], 1)];
  })], 2)], 1), _c('page-section-primary', {
    staticClass: "page-section--last grey lighten-5 pt-60px pt-md-80px",
    attrs: {
      "titWrapClass": "text-center"
    }
  }, [_c('v-row', {
    staticClass: "row--xl"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "image-wrap map-image"
  }, [_c('v-img', {
    attrs: {
      "eager": "",
      "src": "/images/sub/business/environment/map.jpg"
    }
  })], 1)]), _c('v-col', [_c('tit', {
    staticClass: "font-size-24 font-size-md-36 text-center primary--text"
  }, [_vm._v("여의도 ,종로 등 중심업무지구까지 차량으로 30분이내최적의 직주근접")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }